var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6665 6.16663H1.6665V10.8333H3.6665V6.16663Z",
    fill: "#92A9B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.16663H6V10.8333H8V6.16663Z",
    fill: "#92A9B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 12.1666H0.333252V14.1666H13.6666V12.1666Z",
    fill: "#92A9B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 6.16663H10.3333V10.8333H12.3333V6.16663Z",
    fill: "#92A9B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.166626L0.333252 3.49996V4.83329H13.6666V3.49996L6.99992 0.166626Z",
    fill: "#92A9B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.7abaf7f6afbecb6e06803217afe7ebf3.svg";
export { ForwardRef as ReactComponent };